import React, { useState } from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  TextField,
  withStyles,
} from "@material-ui/core";
import { useRootSelector } from "../../store/utils";
import { useDispatch } from "react-redux";
import {
  getCreatingGambler, getIsWithdrawing,
  getNeedsRegister,
  getWrongNetwork,
} from "../../store/Gambler/gambler.selector";
import {createGambler, getFaucet} from "../../store/Gambler/gambler.slice";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Transition } from "./DialogTransition";
import WesternTextureBg from "../../images/background2.jpg";
import CowboyRegisterImg from "../../images/cowboy-register.png";
import InvertColorsIcon from '@material-ui/icons/InvertColors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      borderRadius: 16,
    },
    dialogTitle: {
      padding: theme.spacing(2, 2, 2, 3),
      color: theme.palette.text.secondary,
      backgroundColor: "rgba(0,0,0,.8)",
    },
    dialogContent: {
      padding: theme.spacing(2, 2, 2, 2),
      backgroundImage: `url(${WesternTextureBg})`,
      backgroundSize: 'cover',
    },
    dialogText: {
      padding: theme.spacing(1, 0, 0, 1),
    },
    dialogActions: {
      padding: theme.spacing(1, 3, 1, 1),
      backgroundColor: "rgba(0,0,0,.8)",
    },
    image: {
      width: '100%',
    },
  })
);

const TextFieldStyled = withStyles((theme) => ({
  root: {
    "& .MuiFormLabel-root": {
      color: theme.palette.text.secondary,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: 'white !important'
    },
  },
}))(TextField);

export const RegisterDialog = () => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const needsRegister = useRootSelector(getNeedsRegister);
  const isWithdrawing = useRootSelector(getIsWithdrawing);
  const isWrongNetwork = useRootSelector(getWrongNetwork);
  const isCreatingGambler = useRootSelector(getCreatingGambler);

  const [isValid, setValid] = useState(true);
  const [name, setName] = useState<string>("");

  const handleRegistration = () => {
    if (!name) {
      setValid(false);
      return;
    }
    dispatch(createGambler(name));
  };

  const handleGetFaucet = () => {
    dispatch(getFaucet());
  };

  const handleNameChanged = (value: string) => {
    setValid(Boolean(value));
    if (value.length < 32) setName(value);
  };

  return (
    <Dialog
      open={needsRegister && !isWrongNetwork}
      TransitionComponent={Transition}
      PaperProps={{ className: styles.dialog }}
    >
      <DialogTitle className={styles.dialogTitle}>🤠 Howdy, Gunslinger!</DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <DialogContentText className={styles.dialogText}>
        <span>☀️ Feel the tension rise as the sun sets on the horizon. <br/></span>
        <span>🌵 The stakes are high, and the tumbleweeds are rolling. <br/></span>
        <span>💰 Will you ride into the sunset with pockets jingling, or will you be left in the dust? <br/><br/></span>
        <img className={styles.image} src={CowboyRegisterImg} alt="Cowboy register" />
        </DialogContentText>
        <TextFieldStyled
          fullWidth
          required
          disabled={isCreatingGambler}
          label="Discord ID"
          placeholder="Enter your Discord ID"
          variant="outlined"
          value={name}
          onChange={(evt) => handleNameChanged(evt.target.value)}
        />
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button
            variant="contained"
            disabled={isCreatingGambler || !isValid || isWithdrawing}
            onClick={handleGetFaucet}
            color="primary"
        >
          <InvertColorsIcon />
          Claim GUN
        </Button>
        <Button
          variant="contained"
          disabled={isCreatingGambler || !isValid}
          onClick={handleRegistration}
          color="secondary"
        >
          Sign Up
        </Button>
      </DialogActions>
      {isCreatingGambler ? <LinearProgress /> : null}
    </Dialog>
  );
};
